/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type BookingClassification = "conditional" | "new_arrest" | "not_classified" | "referral" | "released" | "supervised" | "%future added value";
export type YesNo = "no" | "yes" | "%future added value";
export type YesNoUnknown = "no" | "unknown" | "yes" | "%future added value";
export type PrintTransmittalContainerQueryVariables = {
    readonly id?: string | null;
};
export type PrintTransmittalContainerQueryResponse = {
    readonly booking_groups: ({
        readonly booking_group: ReadonlyArray<({
            readonly id: string;
            readonly created_at: string;
            readonly bookings: ReadonlyArray<{
                readonly id: string;
                readonly booking_defendent: {
                    readonly cii_number: string | null;
                    readonly local_id: string | null;
                    readonly cdl_id: string | null;
                    readonly name: {
                        readonly first: string;
                        readonly last: string | null;
                    };
                    readonly date_of_birth: string;
                    readonly sex: string | null;
                    readonly race: string | null;
                };
                readonly booking_info: {
                    readonly booking_sid: string | null;
                    readonly local_id: string | null;
                    readonly booking_number: string | null;
                    readonly booking_datetime: string | null;
                    readonly booking_address: string | null;
                };
                readonly booking_charges: ReadonlyArray<{
                    readonly id: string;
                    readonly booking_charge_sid: string | null;
                    readonly booking_sid: string | null;
                    readonly booking_number: string;
                    readonly booking_datetime: string | null;
                    readonly charge_auth_type: string | null;
                    readonly charge_code_section: string;
                    readonly charge_type: string | null;
                    readonly charge_datetime: string | null;
                    readonly charge_description: string | null;
                    readonly arrest_agency: string | null;
                    readonly arrest_datetime: string | null;
                    readonly crime_case_number: string | null;
                    readonly court_warrant_number: string | null;
                }> | null;
                readonly booking_releases: ReadonlyArray<{
                    readonly charge_code_section: string;
                    readonly charge_description: string;
                    readonly charge_type: string;
                    readonly charge_release_datetime: string;
                    readonly charge_release_type: string;
                    readonly warrant_number: string | null;
                    readonly court_case_number: string | null;
                    readonly jc_control: string | null;
                    readonly created_datetime: string | null;
                }> | null;
                readonly booking_status: ({
                    readonly booking_number: string;
                    readonly court_appearance_datetime: string;
                    readonly court_reason: string | null;
                    readonly court_room: string | null;
                }) | null;
                readonly classification: BookingClassification;
                readonly imported_date: string;
                readonly comments: string | null;
                readonly is_eligible: YesNoUnknown | null;
                readonly spanish_speaker: YesNoUnknown | null;
                readonly has_wait: YesNo | null;
            }>;
            readonly ineligible_bookings: ReadonlyArray<{
                readonly id: string;
                readonly booking_defendent: {
                    readonly cii_number: string | null;
                    readonly local_id: string | null;
                    readonly cdl_id: string | null;
                    readonly name: {
                        readonly first: string;
                        readonly last: string | null;
                    };
                    readonly date_of_birth: string;
                    readonly sex: string | null;
                    readonly race: string | null;
                };
                readonly booking_info: {
                    readonly booking_sid: string | null;
                    readonly local_id: string | null;
                    readonly booking_number: string | null;
                    readonly booking_datetime: string | null;
                    readonly booking_address: string | null;
                };
                readonly booking_charges: ReadonlyArray<{
                    readonly id: string;
                    readonly booking_charge_sid: string | null;
                    readonly booking_sid: string | null;
                    readonly booking_number: string;
                    readonly booking_datetime: string | null;
                    readonly charge_auth_type: string | null;
                    readonly charge_code_section: string;
                    readonly charge_type: string | null;
                    readonly charge_datetime: string | null;
                    readonly charge_description: string | null;
                    readonly arrest_agency: string | null;
                    readonly arrest_datetime: string | null;
                    readonly crime_case_number: string | null;
                    readonly court_warrant_number: string | null;
                }> | null;
                readonly booking_releases: ReadonlyArray<{
                    readonly charge_code_section: string;
                    readonly charge_description: string;
                    readonly charge_type: string;
                    readonly charge_release_datetime: string;
                    readonly charge_release_type: string;
                    readonly warrant_number: string | null;
                    readonly court_case_number: string | null;
                    readonly jc_control: string | null;
                    readonly created_datetime: string | null;
                }> | null;
                readonly booking_status: ({
                    readonly booking_number: string;
                    readonly court_appearance_datetime: string;
                    readonly court_reason: string | null;
                }) | null;
                readonly classification: BookingClassification;
                readonly imported_date: string;
                readonly comments: string | null;
                readonly is_eligible: YesNoUnknown | null;
                readonly spanish_speaker: YesNoUnknown | null;
                readonly has_wait: YesNo | null;
            }> | null;
            readonly email_sent: boolean | null;
        }) | null> | null;
    }) | null;
};
export type PrintTransmittalContainerQuery = {
    readonly response: PrintTransmittalContainerQueryResponse;
    readonly variables: PrintTransmittalContainerQueryVariables;
};



/*
query PrintTransmittalContainerQuery(
  $id: String
) {
  booking_groups(id: $id) {
    booking_group {
      id
      created_at
      bookings {
        id
        booking_defendent {
          cii_number
          local_id
          cdl_id
          name {
            first
            last
          }
          date_of_birth
          sex
          race
        }
        booking_info {
          booking_sid
          local_id
          booking_number
          booking_datetime
          booking_address
        }
        booking_charges {
          id
          booking_charge_sid
          booking_sid
          booking_number
          booking_datetime
          charge_auth_type
          charge_code_section
          charge_type
          charge_datetime
          charge_description
          arrest_agency
          arrest_datetime
          crime_case_number
          court_warrant_number
        }
        booking_releases {
          charge_code_section
          charge_description
          charge_type
          charge_release_datetime
          charge_release_type
          warrant_number
          court_case_number
          jc_control
          created_datetime
        }
        booking_status {
          booking_number
          court_appearance_datetime
          court_reason
          court_room
        }
        classification
        imported_date
        comments
        is_eligible
        spanish_speaker
        has_wait
      }
      ineligible_bookings {
        id
        booking_defendent {
          cii_number
          local_id
          cdl_id
          name {
            first
            last
          }
          date_of_birth
          sex
          race
        }
        booking_info {
          booking_sid
          local_id
          booking_number
          booking_datetime
          booking_address
        }
        booking_charges {
          id
          booking_charge_sid
          booking_sid
          booking_number
          booking_datetime
          charge_auth_type
          charge_code_section
          charge_type
          charge_datetime
          charge_description
          arrest_agency
          arrest_datetime
          crime_case_number
          court_warrant_number
        }
        booking_releases {
          charge_code_section
          charge_description
          charge_type
          charge_release_datetime
          charge_release_type
          warrant_number
          court_case_number
          jc_control
          created_datetime
        }
        booking_status {
          booking_number
          court_appearance_datetime
          court_reason
        }
        classification
        imported_date
        comments
        is_eligible
        spanish_speaker
        has_wait
      }
      email_sent
    }
  }
}
*/

const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "id",
            "type": "String",
            "defaultValue": null
        } as any)
    ], v1 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any), v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "local_id",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "booking_defendent",
        "storageKey": null,
        "args": null,
        "concreteType": "BookingDefendent",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "cii_number",
                "args": null,
                "storageKey": null
            },
            (v2 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "cdl_id",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "name",
                "storageKey": null,
                "args": null,
                "concreteType": "PersonName",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "first",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "last",
                        "args": null,
                        "storageKey": null
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "date_of_birth",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "sex",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "race",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "booking_sid",
        "args": null,
        "storageKey": null
    } as any), v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "booking_number",
        "args": null,
        "storageKey": null
    } as any), v6 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "booking_datetime",
        "args": null,
        "storageKey": null
    } as any), v7 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "booking_info",
        "storageKey": null,
        "args": null,
        "concreteType": "BookingInfo",
        "plural": false,
        "selections": [
            (v4 /*: any*/),
            (v2 /*: any*/),
            (v5 /*: any*/),
            (v6 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "booking_address",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v8 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "charge_code_section",
        "args": null,
        "storageKey": null
    } as any), v9 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "charge_type",
        "args": null,
        "storageKey": null
    } as any), v10 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "charge_description",
        "args": null,
        "storageKey": null
    } as any), v11 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "booking_charges",
        "storageKey": null,
        "args": null,
        "concreteType": "BookingCharge",
        "plural": true,
        "selections": [
            (v1 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "booking_charge_sid",
                "args": null,
                "storageKey": null
            },
            (v4 /*: any*/),
            (v5 /*: any*/),
            (v6 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "charge_auth_type",
                "args": null,
                "storageKey": null
            },
            (v8 /*: any*/),
            (v9 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "charge_datetime",
                "args": null,
                "storageKey": null
            },
            (v10 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "arrest_agency",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "arrest_datetime",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "crime_case_number",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "court_warrant_number",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v12 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "booking_releases",
        "storageKey": null,
        "args": null,
        "concreteType": "BookingRelease",
        "plural": true,
        "selections": [
            (v8 /*: any*/),
            (v10 /*: any*/),
            (v9 /*: any*/),
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "charge_release_datetime",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "charge_release_type",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "warrant_number",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "court_case_number",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "jc_control",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "created_datetime",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v13 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "court_appearance_datetime",
        "args": null,
        "storageKey": null
    } as any), v14 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "court_reason",
        "args": null,
        "storageKey": null
    } as any), v15 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "classification",
        "args": null,
        "storageKey": null
    } as any), v16 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "imported_date",
        "args": null,
        "storageKey": null
    } as any), v17 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "comments",
        "args": null,
        "storageKey": null
    } as any), v18 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "is_eligible",
        "args": null,
        "storageKey": null
    } as any), v19 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "spanish_speaker",
        "args": null,
        "storageKey": null
    } as any), v20 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "has_wait",
        "args": null,
        "storageKey": null
    } as any), v21 = [
        ({
            "kind": "LinkedField",
            "alias": null,
            "name": "booking_groups",
            "storageKey": null,
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "id"
                }
            ],
            "concreteType": "Pagination",
            "plural": false,
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "booking_group",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "BookingGroup",
                    "plural": true,
                    "selections": [
                        (v1 /*: any*/),
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "created_at",
                            "args": null,
                            "storageKey": null
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "bookings",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Booking",
                            "plural": true,
                            "selections": [
                                (v1 /*: any*/),
                                (v3 /*: any*/),
                                (v7 /*: any*/),
                                (v11 /*: any*/),
                                (v12 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "booking_status",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "BookingStatus",
                                    "plural": false,
                                    "selections": [
                                        (v5 /*: any*/),
                                        (v13 /*: any*/),
                                        (v14 /*: any*/),
                                        {
                                            "kind": "ScalarField",
                                            "alias": null,
                                            "name": "court_room",
                                            "args": null,
                                            "storageKey": null
                                        }
                                    ]
                                },
                                (v15 /*: any*/),
                                (v16 /*: any*/),
                                (v17 /*: any*/),
                                (v18 /*: any*/),
                                (v19 /*: any*/),
                                (v20 /*: any*/)
                            ]
                        },
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "ineligible_bookings",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Booking",
                            "plural": true,
                            "selections": [
                                (v1 /*: any*/),
                                (v3 /*: any*/),
                                (v7 /*: any*/),
                                (v11 /*: any*/),
                                (v12 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "booking_status",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "BookingStatus",
                                    "plural": false,
                                    "selections": [
                                        (v5 /*: any*/),
                                        (v13 /*: any*/),
                                        (v14 /*: any*/)
                                    ]
                                },
                                (v15 /*: any*/),
                                (v16 /*: any*/),
                                (v17 /*: any*/),
                                (v18 /*: any*/),
                                (v19 /*: any*/),
                                (v20 /*: any*/)
                            ]
                        },
                        {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "email_sent",
                            "args": null,
                            "storageKey": null
                        }
                    ]
                }
            ]
        } as any)
    ];
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "PrintTransmittalContainerQuery",
            "type": "Query",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v21 /*: any*/)
        },
        "operation": {
            "kind": "Operation",
            "name": "PrintTransmittalContainerQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": (v21 /*: any*/)
        },
        "params": {
            "operationKind": "query",
            "name": "PrintTransmittalContainerQuery",
            "id": null,
            "text": "query PrintTransmittalContainerQuery(\n  $id: String\n) {\n  booking_groups(id: $id) {\n    booking_group {\n      id\n      created_at\n      bookings {\n        id\n        booking_defendent {\n          cii_number\n          local_id\n          cdl_id\n          name {\n            first\n            last\n          }\n          date_of_birth\n          sex\n          race\n        }\n        booking_info {\n          booking_sid\n          local_id\n          booking_number\n          booking_datetime\n          booking_address\n        }\n        booking_charges {\n          id\n          booking_charge_sid\n          booking_sid\n          booking_number\n          booking_datetime\n          charge_auth_type\n          charge_code_section\n          charge_type\n          charge_datetime\n          charge_description\n          arrest_agency\n          arrest_datetime\n          crime_case_number\n          court_warrant_number\n        }\n        booking_releases {\n          charge_code_section\n          charge_description\n          charge_type\n          charge_release_datetime\n          charge_release_type\n          warrant_number\n          court_case_number\n          jc_control\n          created_datetime\n        }\n        booking_status {\n          booking_number\n          court_appearance_datetime\n          court_reason\n          court_room\n        }\n        classification\n        imported_date\n        comments\n        is_eligible\n        spanish_speaker\n        has_wait\n      }\n      ineligible_bookings {\n        id\n        booking_defendent {\n          cii_number\n          local_id\n          cdl_id\n          name {\n            first\n            last\n          }\n          date_of_birth\n          sex\n          race\n        }\n        booking_info {\n          booking_sid\n          local_id\n          booking_number\n          booking_datetime\n          booking_address\n        }\n        booking_charges {\n          id\n          booking_charge_sid\n          booking_sid\n          booking_number\n          booking_datetime\n          charge_auth_type\n          charge_code_section\n          charge_type\n          charge_datetime\n          charge_description\n          arrest_agency\n          arrest_datetime\n          crime_case_number\n          court_warrant_number\n        }\n        booking_releases {\n          charge_code_section\n          charge_description\n          charge_type\n          charge_release_datetime\n          charge_release_type\n          warrant_number\n          court_case_number\n          jc_control\n          created_datetime\n        }\n        booking_status {\n          booking_number\n          court_appearance_datetime\n          court_reason\n        }\n        classification\n        imported_date\n        comments\n        is_eligible\n        spanish_speaker\n        has_wait\n      }\n      email_sent\n    }\n  }\n}\n",
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = 'f36c762c6c7effd620a1aa95e02c574a';
export default node;
